const sysCd = {
  10: '10',
  20: '20',
  21: '21',
  23: '23',
  30: '30',
  35: '35',
  50: '50',
  60: '60',
  80: '80',
}

const sysId = {
  10: 'V_10',
  20: 'V_20',
  21: 'V_21',
  23: 'V_23',
  30: 'V_30',
  35: 'V_35',
  50: 'V_50',
  60: 'V_60',
  80: 'V_80',
}

export default {
  namespaced: true,

  state : {
      sysCd: '',
      sysId: ''
  },
  mutations: {
    SET_SYS_CD: (state, system) => {
      state.sysCd = sysCd[system] ? sysCd[system] : ''
    },
    SET_SYS_ID: (state, system) => {
      state.sysId = sysId[system] ? sysId[system] : ''
    }
  },
  actions: {
    ClearSession({
      commit
    }) {
      commit('SET_SYS_CD', '')
      commit('SET_SYS_ID', '')
    }
  }
}